<template>
  <div class="pad-3">
    <div class="bb-container bb-container--lista">
      <h1 class="header-1">{{ $t("legalNotice.legalNotice", lang) }}</h1>
      <div class="post-entry">
        <h3>{{ $t("legalNotice.art1", lang) }}</h3>
        <p>
          {{ $t("legalNotice.art1Text", lang) }}
        </p>

        <h3>{{ $t("legalNotice.art2", lang) }}</h3>
        <p>
          {{ $t("legalNotice.art2Text1", lang) }}
        </p>
        <p>
          {{ $t("legalNotice.art2Text2", lang) }}
        </p>
        <p>
          {{ $t("legalNotice.art2Text3", lang) }}
        </p>
        <p>
          {{ $t("legalNotice.art2Text4", lang) }}
        </p>
        <p>
          {{ $t("legalNotice.art2Text5", lang) }}
        </p>

        <p>
          {{ $t("legalNotice.art2Text6", lang) }}
        </p>

        <h3>{{ $t("legalNotice.art3", lang) }}</h3>

        <p>
          {{ $t("legalNotice.art3Text1", lang) }}
          <br />
        </p>
        <p>
          {{ $t("legalNotice.art3Text2", lang) }}
        </p>

        <p>
          {{ $t("legalNotice.art3Text3", lang) }}
        </p>
        <h3>{{ $t("legalNotice.art4", lang) }}</h3>
        <p>
          {{ $t("legalNotice.art4Text1", lang) }}
        </p>
        <p>{{ $t("legalNotice.art4Text2", lang) }}</p>
        <p>
          {{ $t("legalNotice.art4Text3", lang) }}
        </p>
        <p>
          {{ $t("legalNotice.art4Text4", lang) }}
        </p>
        <p>
          {{ $t("legalNotice.art4Text5", lang) }}
        </p>
        <h3>{{ $t("legalNotice.art5", lang) }}</h3>
        <p>
          {{ $t("legalNotice.art5Text1", lang) }}
        </p>
        <p>
          {{ $t("legalNotice.art5Text2", lang) }}
        </p>
        <p>
          {{ $t("legalNotice.art5Text3", lang) }}
        </p>
        <p>
          {{ $t("legalNotice.art5Text4", lang) }}
        </p>
        <h3>{{ $t("legalNotice.art6", lang) }}</h3>
        <p>
          {{ $t("legalNotice.art6Text1", lang) }}
        </p>
        <p>
          {{ $t("legalNotice.art6Text2", lang) }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { buildSeoMetaInfo } from "../../seo/buildSeoMetaInfo.js";
import { HTML_LANG_MAP } from "../../seo/langMaps.js";

const URL_ALTS = {
  "es": "https://www.hellobb.net/legal",
  "fr-FR": "https://www.hellobb.net/mentions-legales",
  "it-IT": "https://www.hellobb.net/avviso-legale",
  "pt-BR": "https://www.hellobb.net/termos-legais",
  "nl-NL": "https://www.hellobb.net/juridisch",
  "de-DE": "https://www.hellobb.net/rechtliches",
  "en-GB": "https://www.hellobb.net/legal-notice",
  "x-default": "https://www.hellobb.net/legal",
}

export default {
  name: "Legal",
  metaInfo() {
    return buildSeoMetaInfo({
      vm: this,
      alts: URL_ALTS,
      appLang: this.lang,
      htmlLangMap: HTML_LANG_MAP,
      title: this.$t("legalNotice.metaTitle", this.lang),
      description: this.$t("legalNotice.metaDescription", this.lang),
    });
  },
  computed: {
    lang() {
      return this.$route.meta?.lang || this.$i18n.locale;
    }
  }
};
</script>
